import * as React from "react";

import './LiveBadge.pcss';
export const LiveBadge = () =>
  <span className={"live-badge"}>LIVE</span>
